<template>
  <section>
    <v-container fluid v-if="session">
      <v-row>
        <v-col cols="12" md="5">
          <v-toolbar dense color="blur">Candidate answers
          <v-spacer/>
            <v-btn small color="primary" @click="generateAnswers">generate answers from templates</v-btn>
          </v-toolbar>
          <v-card class="my-2" v-for="answer in answers" :key="answer.id">
            <template v-if="answer.type === 'text'">
              <v-toolbar dense flat outlined>{{ answer.name }}</v-toolbar>
              <div class="ql-editor" v-html="answer.body"></div>
            </template>
            <template v-else-if="answer.type === 'google_doc'">
              <v-list-item :disabled="!answer.google_view_link" :href="answer.google_view_link" target="_blank">
                <v-list-item-avatar tile size="50">
                  <img :src="`/img/google/${getIcon(answer)}.png`" alt="">
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ answer.name }}</v-list-item-title>
                </v-list-item-content>

                <v-btn small color="success" target="_blank"
                       :disabled="!answer.google_view_link"
                       :href="answer.google_view_link">
                  <v-icon>mdi-link</v-icon>

                  open
                </v-btn>
              </v-list-item>
            </template>
            <!--          <template v-else-if="answer.type === 'jpg'|| answer.type === 'jpeg' || answer.type === 'jpg'">-->
            <!--            <v-img :src="answer.file" width="100%"/>-->
            <!--          </template>-->
            <!--          <template v-else-if="answer.type === 'image/jpeg'|| answer.type === 'image/png'">-->
            <!--            <v-img :src="answer.file" width="100%"/>-->
            <!--          </template>-->
            <!--          <template v-else-if="answer.type === 'application/pdf'">-->
            <!--            <embed :type="answer.type" :src="answer.file" width="100%" height="500px">-->
            <!--          </template>-->
            <template v-else>
              <AnswerPreview :answer="answer"></AnswerPreview>

              <!--            <embed :type="answer.type" :src="answer.file" width="100%" height="500px">-->
            </template>
          </v-card>
        </v-col>
        <v-col cols="12" md="7" v-if="session.response">
          <v-card class="mb-3" v-if="session.response.marking_layout">
            <v-toolbar dense color="blur">Marking layout</v-toolbar>
            <embed :src="base64toBlob(session.response.marking_layout)" width="100%" height="600px">
          </v-card>

          <v-card class="mb-3" v-if="session.response.body">
            <v-toolbar dense color="blur">Response</v-toolbar>
            <embed :src="base64toBlob(session.response.body)" width="100%" height="600px">
          </v-card>

        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import AnswerPreview from "@/views/sessions/AnswerPreview";
import { base64StringToBlob, createObjectURL } from 'blob-util';

export default {
  components: {AnswerPreview},
  props: {
    session: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    mimetypes: [
      {value: 'application/vnd.google-apps.document', text: 'Document', icon: 'document'},
      {value: 'application/vnd.google-apps.drawing', text: 'Drawing', icon: 'drawing'},
      {value: 'application/vnd.google-apps.form', text: 'Form', icon: 'form'},
      {value: 'application/vnd.google-apps.presentation', text: 'Presentation', icon: 'presentation'},
      {value: 'application/vnd.google-apps.spreadsheet', text: 'Sheets', icon: 'spreadsheet'},
      // {value: 'application/vnd.google-apps.photo', text: 'Photo', icon: 'photo'},
      // {value: 'application/vnd.google-apps.video', text: 'video', icon: 'video'},
    ],
    answers: []
  }),
  created() {
    this.loadAnswers()
  },
  methods: {
    async loadAnswers() {
      this.answers = await this.axios.get(`api/sessions/${this.$route.params.session_id}/answers`)
          .then(({data}) => data.data)
    },
    async generateAnswers() {
      await this.axios.post(`api/sessions/${this.$route.params.session_id}/answers`)
          .then(() => {
            this.loadAnswers()
          })
    },
    getIcon(document) {
      if(document.google_mimetype) {
        let mimetype = this.mimetypes.find(item => item.value === document.google_mimetype)
        if(mimetype) return mimetype.icon
      }
      return null
    },

    base64toBlob(base64Data) {
      const blob = base64StringToBlob(base64Data, 'application/pdf');
      return createObjectURL(blob)
    },
  }

}
</script>